<template>
  <div>
    <MyBreadcrumb
      :breadcrumb-list="[
        {text:'应用列表',to:'/app/market/index'},
        {text:'订购记录',to:''}
      ]"
    ></MyBreadcrumb>
    <div :class="[{'wrap-box':!inIframe}]">
      <div
        v-if="!inIframe"
        class="wrap-left"
      >
        <div
          class="nav-item "
          @click="goMyApp"
        >
          我的应用
        </div>
        <div
          class="nav-item select"
        >
          订购记录
        </div>
      </div>
      <div :class="[{'wrap-right':!inIframe}]">
        <!-- 数据未加载出来时显示骨架屏 -->
        <skeleton v-if="tablePage.loading"></skeleton>
        <MyTablePage
          v-else
          ref="myTablePage"
          v-model="tablePage.params"
          class="myTablePage"
          :load-data="tablePage.on.loadData"
          :data="tablePage.data"
          :total="tablePage.total"
          :columns="tablePage.columns"
          :form-items="tablePage.formItems"
          :label-width="70"
          :autoload="false"
          :show-page="true"
        >
        </MyTablePage>
      </div>
    </div>
  </div>
</template>

<script>
import MyTablePage from '@/components/Template/TablePage';
import moment from 'moment';
import skeleton from './components/Skeleton';
import {inIframe} from '@/common/createMicroApp/utils';
export default {
  components: { MyTablePage,skeleton },
  data() {
    return {

      tablePage: {
        loading: true,
        data: [],
        total: 0,
        columns: [
          {
            title: '订购服务',
            key: 'version',
            align: 'center',
            width: 260,
            render: (h,params)=>{
              const {productImage,productName,productCode,productType} = params.row;
              const html = [];
              const img = h('img',{
                style: {
                  width: '66px',
                  height: '44px',
                  verticalAlign: 'middle',
                  marginRight: '5px',
                  flexShrink: 0,
                },
                attrs: {
                  src: productImage,
                },
              });
              html.push(img);
              const span = h('span',productName);
              html.push(span);
              return h(
                'div',
                {
                  style: 'display:flex;align-items: center;padding:20px 0;cursor:pointer',
                  on: {
                    click: ()=>{
                      let path = '/app/appDetail/index';
                      if (productType===1){
                        // productType: 2, // 1 产品 2应用
                        path = '/standardProduct/productVersion/index';
                      }
                      this.$router.push({
                        path,
                        query: {
                          productCode,
                        },
                      });
                    },
                  },
                },
                html,
              );
            },
          },
          // {
          //   title: '订单编号',
          //   key: 'orderNo',
          //   align: 'center',
          // },
          {
            title: '服务周期',
            key: 'servicePeriod',
            align: 'center',
            // width: 100,
          },
          {
            title: '订购金额',
            key: 'payFee',
            align: 'center',
            render: (h,params)=>{
              const {payFee} = params.row;
              const html = [];
              const span = h('span',`￥${this.$options.filters.moneyFix(payFee)}`);
              html.push(span);
              return html;
            },
            // width: 100,
          },
          {
            title: '创建时间',
            key: 'orderTime',
            align: 'center',
          },
          {
            title: '状态',
            key: 'orderStatus',
            align: 'center',
            // width: 100,
            render: (h,params)=>{
              const {orderStatus,payChannel} = params.row;
              const statusObj = {
                1: '待付款',
                3: '支付处理中',
                5: '订购成功',
                7: '已关闭',
                9: '支付失败',
                11: '审核拒绝',
              };
              // #F86138 #11CB64 #666666
              const colorObj = {
                1: '#666666',
                3: '#11CB64',
                5: '#11CB64',
                7: '#666666',
                9: '#F86138',
                11: '#F86138',
              };
              let color = colorObj[orderStatus];
              let orderStatusDesc = statusObj[orderStatus];
              if (orderStatus===3 && payChannel===3){
                orderStatusDesc = '款项待核实';
                color = '#666666';
              }
              return h('span',{style: {color}},orderStatusDesc);
            },
          },
          {
            title: '操作',
            key: 'period',
            align: 'center',
            render: (h,params)=>{
              const {orderStatus,orderNo,accountNo,productCode} = params.row;
              const html = [];
              // 详情
              const detailSpan = h('span',{
                style: {
                  marginRight: '10px',
                  color: '#409EFF',
                  cursor: 'pointer',
                },
                on: {
                  click: ()=>{
                    this.$router.push({
                      path: '/app/orderRecord/Detail',
                      query: {
                        orderNo,
                        // orderStatus: orderStatus,
                      },
                    });
                  },
                },
              },'详情');
              html.push(detailSpan);
              if (Number(orderStatus)===1){
                // 去支付
                const payBtn = h('Button',{
                  props: {
                    shape: 'circle',
                    type: 'primary',
                    size: 'small',
                  },
                  on: {
                    click: ()=>{
                      this.pay({
                        orderNo,
                        accountNo,
                        productCode,
                      });
                      // this.$router.push({
                      //   path: '/pay/index',
                      // });
                    },
                  },
                },'去支付');
                html.push(payBtn);
              }

              return html;
            },
          },
        ],
        formItems: [
          {
            label: '订购状态',
            prop: 'orderStatus',
            type: 'select',
            placeholder: '请选择订购状态',
            data: ()=>{
              return this.$store.dispatch('getOrderStatus');
            },
            // on: {
            //   'on-change': (value) => {
            //     if (value) {
            //       this.search(1);
            //     }
            //   },
            // },
          },
          {
            label: '订购日期',
            prop: 'startTime',
            type: 'date',
            placeholder: '请选择开始时间',
            format: 'yyyy-MM-dd',
            options: {
              disabledDate: date => {
                let disabled = false;
                const { endTime } = this.tablePage.params;
                if (endTime) {
                  if (date.getTime() > new Date(`${endTime} 23:59:59`).getTime()) {
                    // 结束日期不得小于开始日期
                    disabled = true;
                  } else if (date.getTime() < new Date(endTime).getTime() - 30 * 24 * 60 * 60 * 1000) {
                    // 结束日期与开始日期相差不超过30天
                    disabled = true;
                  }
                }

                return disabled;
              },
            },
            on: {
              input: (date) => {
                if (!date) {
                  this.tablePage.params.startTime = '';
                  return;
                }
                this.tablePage.params.startTime = moment(date).format('YYYY-MM-DD');
              },
              // 'on-change': (date) => {
              //   this.tablePage.params.startTime = date;
              // },
            },
          },
          {
            prop: 'endTime',
            type: 'date',
            placeholder: '请选择结束时间',
            format: 'yyyy-MM-dd',
            options: {
              disabledDate: date => {
                let disabled = false;
                // 如果date 和开始日期相同， 且没有时分秒 时间戳加 24小时
                const { startTime } = this.tablePage.params;
                if (startTime) {
                  const time = date.getTime();

                  if (time < new Date(`${startTime} 00:00:00`).getTime()) {
                    // 结束日期不得小于开始日期
                    disabled = true;
                  } else if (date.getTime() > new Date(startTime).getTime() + 30 * 24 * 60 * 60 * 1000) {
                    // 结束日期与开始日期相差不超过30天
                    disabled = true;
                  }
                }
                return disabled;
              },
            },
            on: {
              input: (date) => {
                if (!date) {
                  this.tablePage.params.endTime = '';
                  return;
                }
                this.tablePage.params.endTime = moment(date).format('YYYY-MM-DD');
              },
              // 'on-change': (date) => {
              //   this.tablePage.params.endTime = date;
              // },
            },
          },
        ],
        params: {
          limit: 10,
          page: 1,
          // orderSource: this.$route.query.orderSource||'101',
          // startTime: moment().format('YYYY-MM-DD'),
        },
        on: {
          loadData: (callback) => {
            // const {orderSource,corpCode,corpName} = this.$route.query;
            // 检查是否认证
            const {corpList,token} = this.$store.state.user.userInfo;
            if (token && (!corpList||!corpList.length)){
              // 弹出去认证弹框
              this.$root.$emit('show-auth-modal');
              // this.tablePage.loading = false;
              // return;
            }
            const {
              corpCode,
              corpName,
              orderSource,
            } = this.$store.state.user.userInfo;
            // const url = '/paycenter-charge/api/facade/order/page';
            const url = '/paycenter-charge/api/worktable/order/page';
            const params = {
              ...this.tablePage.params,
              orderSource,corpCode,corpName,
            };
            if (!corpCode){
              if (typeof callback === 'function'){
                callback({
                  success: false,
                  // message: '缺少主体',
                });
              } else {
                this.tablePage.loading = false;
              }

              return;
            }
            const {startTime,endTime} = params;
            if (startTime){
              params.startTime = moment(`${startTime} 00:00:00`).unix()*1000;
            }
            if (endTime){
              params.endTime = moment(`${endTime} 23:59:59`).unix()*1000;
            }
            // this.tablePage.loading = true;
            this.$http.get(url, this.common.utils.trim(params)).then(res => {
              let rows = [];
              if (res.success) {
                this.tablePage.loading = false;
                rows = res.data.map(ele => {
                  return ele;
                });
              }


              if (typeof callback === 'function'){
                const data = {
                  ...res,
                  data: {
                    rows,
                    total: res.total,
                  },
                };
                callback(data);
              } else {
                this.tablePage.data = rows;
                this.tablePage.total = res.total;
                if (!res.success){
                  this.$Message.warning(res.message||'请求失败');
                }
              }

            });
          },
        },
      },
      inIframe,
    };
  },
  created() {

    // 获取列表数据
    this.tablePage.on.loadData();

  },
  mounted(){
    console.log(`${123456789}created`);
    // 头部主体变化事件绑定
    // 防止多次监听
    // this.$root.$off('on-corp-change');
    this.$root.$on('on-corp-change', () => {
      // 重新获取已订购的产品
      // this.tablePage.on.loadData();
      this.$refs.myTablePage.getList(1);
    });
  },
  beforeDestroy(){
    console.log(`${123456789}destroyed`);
    // 防止多次监听
    this.$root.$off('on-corp-change');
  },
  methods: {
    goMyApp(){
      this.$router.push('/app/myApp/index');
    },
  },
};
</script>

<style scoped lang="less">
.wrap-box {
  display: flex;
  .wrap-left {
    box-sizing: border-box;
    // flex-shrink: 0;
    width: 15%;
    background-color: #fff;
    padding: 20px;
    .nav-item {
      cursor: pointer;
      margin-bottom: 10px;
      padding: 5px 0;
      text-align: center;
      &.select {
        color: #fff;
        background-color: #5e7ce0;
      }
    }
  }
  .wrap-right {
    // flex-shrink: 0;
    width: 85%;
  }
}
.breadcrumb-box {
  // background-color: #fff;
  padding-bottom: 20px;
  position: relative;
}
.myTablePage {
  background-color: #fff;
  padding: 20px 40px;
}
</style>
